// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'axios'

// ** Contacts
export const getInventoryList = createAsyncThunk('appInventory/getInventoryList', async params => {   
    params.page = params.page === 0 ? 0 : params.page - 1
    const response = await axios.post(`https://api.mfauto.com.ua/repair/inventory/list?env=${process.env.REACT_APP_NODE_ENV}`, {
        ...params,
        token: localStorage.getItem('token')
    })

    return {
        params,
        data: response.data.inventory,
        totalPrice: response.data.total_price,
        totalQuantity: response.data.total_quantity,
        totalPages: response.data.total_elements
    }
})

export const addInventoryItem = createAsyncThunk('appInventory/addInventoryItem', async (data) => {
    const response = await axios.post(`https://api.mfauto.com.ua/repair/inventory/add?env=${process.env.REACT_APP_NODE_ENV}`, {
        ...data,
        token: localStorage.getItem('token')
    })
    return response.data
})

export const updateInventoryItem = createAsyncThunk('appInventory/updateInventoryItem', async (data) => {
    const response = await axios.post(`https://api.mfauto.com.ua/repair/inventory/edit?env=${process.env.REACT_APP_NODE_ENV}`, {
        ...data,
        token: localStorage.getItem('token')
    })
    return response.data
})
export const getInventoryItem = createAsyncThunk('appInventory/getInventoryItem', async (id) => {
    const response = await axios.post(`https://api.mfauto.com.ua/repair/inventory/get?env=${process.env.REACT_APP_NODE_ENV}`, {
        id,
        token: localStorage.getItem('token')
    })
    return response.data
})
export const removeInventoryItem = createAsyncThunk('appInventory/removeInventoryItem', async (id) => {
    const response = await axios.post(`https://api.mfauto.com.ua/repair/inventory/remove?env=${process.env.REACT_APP_NODE_ENV}`, {
        id,
        token: localStorage.getItem('token')
    })
    return response.data
})

export const addInventoryItemOperatorRecord = createAsyncThunk('appInventory/addInventoryItemOperatorRecord', async (data) => {
    const response = await axios.post(`https://api.mfauto.com.ua/repair/inventory/operator/add?env=${process.env.REACT_APP_NODE_ENV}`, {
        ...data,
        token: localStorage.getItem('token')
    })
    return response.data
})

export const completeInventoryItemOperatorRecord = createAsyncThunk('appInventory/completeInventoryItemOperatorRecord', async (data) => {
    const response = await axios.post(`https://api.mfauto.com.ua/repair/inventory/operator/complete?env=${process.env.REACT_APP_NODE_ENV}`, {
        ...data,
        token: localStorage.getItem('token')
    })
    return response.data
})

export const appInventorySlice = createSlice({
    name: 'appInventory',
    initialState: {        
        data: [],
        total: 1,
        params: {},
        total_price: 0,
        total_quantity: 0,
        settings: [],
        selectedContact: null
    },
    reducers: {},
    extraReducers: builder => {
        builder
        .addCase(getInventoryList.fulfilled, (state, action) => {
            state.data = action.payload.data
            state.params = action.payload.params
            state.total = action.payload.totalPages
            state.total_price = action.payload.totalPrice
            state.total_quantity = action.payload.totalQuantity
        })
    }
})

export default appInventorySlice.reducer